import { render, staticRenderFns } from "./HouseholdsListing.vue?vue&type=template&id=44ec57e4&scoped=true"
import script from "./HouseholdsListing.vue?vue&type=script&lang=js"
export * from "./HouseholdsListing.vue?vue&type=script&lang=js"
import style0 from "./HouseholdsListing.vue?vue&type=style&index=0&id=44ec57e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44ec57e4",
  null
  
)

export default component.exports